import React from "react";
import { Stack, Text } from "office-ui-fabric-react";
import { get, titleCase } from "sites-common/utils/lodash";
import {
  doFormatShortDate,
  formatSys2OdooDate,
} from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";
import { daysDiff } from "@heartfulnessinstitute/react-hfn-forms/dist/utils";
import { Div } from "../../components/Bootstrap";
import { DocumentsButton, SittingsButton } from "../../common1/buttons";
import { buttonStyles } from "../../components/Button";

const strings = require("../../care-app/strings.json");

const today = formatSys2OdooDate(new Date());

const divStatus = (item) =>
  item.status !== "active" && (
    <Div
      className={`badge ${
        item.status === "discontinued"
          ? "badge-danger"
          : item.status === "expired"
          ? "badge-info"
          : "badge-success"
      }`}
    >
      {strings.status_opts[item.status]}
    </Div>
  );

const divLastSittingDate = (item) => (
  <div>
    <Div
      className={`mr-1 badge ${
        !item.last_sitting_date ? "badge-danger" : "badge-success"
      }`}
    >
      {!!item.last_sitting_date && doFormatShortDate(item.last_sitting_date)}{" "}
      {!item.last_sitting_date && item.last_sitting_type}
    </Div>
    {item.last_sitting_date !== "" && (
      <span>
        <small>last sitting: {item.last_sitting_days} days ago</small>
      </span>
    )}
  </div>
);

const divTrainers = (trainersMap) => (item) =>
  (
    <div>
      {get(item, "caretrainers", []).map((trainer) => (
        <div key={trainer}>{get(trainersMap, trainer, trainer)}</div>
      ))}
    </div>
  );

export const RenderColumns = (primaryKey, trainersMap) => [
  ["Name", (r) => titleCase(r.name)],
  ["Gender / Age", ["gender", "age"]],
  ["City", (r) => titleCase(r.city)],
  ["State / Country", ["state", "country"]],
  [
    "Added On",
    (item) => (
      <div>
        {doFormatShortDate(item.added_on)}
        <div>
          <small>{daysDiff(today, item.added_on)} days ago</small>
        </div>
      </div>
    ),
  ],
  ["Status", divStatus],
  ["Last Sitting Date", divLastSittingDate],
  [
    "Sittings",
    (item, passConfig) => (
      <SittingsButton item={item} passConfig={passConfig} />
    ),
  ],
  ["Trainers", divTrainers(trainersMap)],
];

export const ItemCard = ({
  item,
  EditItemButton,
  Config,
  setRenderInPanel,
}) => {
  const cotrainers = get(item, "caretrainers", []).filter(
    (t) => t !== Config.who_am_i
  );
  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <div>
          <Text variant="xLarge">{titleCase(item.name)}</Text>&nbsp; ({" "}
          <Text variant="small">
            {item.gender} {item.age}
          </Text>{" "}
          )&nbsp;&nbsp;
          <Text>
            {titleCase(item.city)} {item.state} {item.country}
          </Text>
        </div>

        {divLastSittingDate(item)}
      </div>
      <div style={{ color: "blue", marginBottom: "10", marginTop: 10 }}>
        {cotrainers.length > 0 && (
          <>
            <Text variant="small">Co-Trainers: </Text>
            <Text>{cotrainers.join(", ")}</Text>
          </>
        )}
      </div>
      {item.added_by_name && (
        <div style={{ marginBottom: 10 }}>
          <>
            <Text variant="small">Added By: </Text>
            <Text>{item.added_by_name}</Text>
          </>
        </div>
      )}

      <Stack
        horizontal
        horizontalAlign="space-between"
        wrap
        tokens={{ childrenGap: 5 }}
      >
        <SittingsButton
          item={item}
          passConfig={{ setRenderInPanel, Config }}
          btnType="default"
          btnProps={{ styles: buttonStyles.warningLight, text: "Sittings" }}
        />
        <div>
          <EditItemButton />
          <DocumentsButton
            item={item}
            passConfig={{ setRenderInPanel, Config }}
            btnType="action"
            btnProps={{
              iconProps: { iconName: "ThumbnailView" },
              text: "Uploads",
            }}
          />
        </div>
      </Stack>
    </div>
  );
};
